import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { businessInfo } from "../mock";
import { Button } from "./ui/button";

const navItems = [
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "Book", href: "/book", external: true },
  { label: "About", href: "#about" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" }
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-black/90 backdrop-blur border-b border-red-900/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <img
            src={businessInfo.logoUrl}
            alt="1/2 Fast Mobile Keys"
            className="h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm font-semibold tracking-wide text-zinc-200 hover:text-red-500 transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <Button asChild className="bg-brand-red text-white font-semibold h-11 px-5">
            <a href={`tel:${businessInfo.phoneRaw}`}>
              <Phone className="w-4 h-4 mr-2" />
              {businessInfo.phone}
            </a>
          </Button>
        </div>

        <button
          className="lg:hidden p-2 rounded-md text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-red-900/40">
          <div className="px-5 py-4 flex flex-col gap-1">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-zinc-200 font-medium py-3 border-b border-zinc-900"
              >
                {n.label}
              </a>
            ))}
            <a
              href={`tel:${businessInfo.phoneRaw}`}
              className="mt-3 bg-brand-red text-white font-semibold rounded-md px-4 py-3 text-center"
            >
              <Phone className="w-4 h-4 mr-2 inline" />
              Call {businessInfo.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
